import styled from 'styled-components';

import {ms} from '../../../../../../../styles';
import {Clickable} from '../../../../../../../uikit/Clickable';
import {View} from '../../../../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: column;
  gap: ${ms(12)};
`;

export const Option = styled(Clickable)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${ms(12)};
`;
